import { render, staticRenderFns } from "./KeukenStart.vue?vue&type=template&id=236ece3a&"
import script from "./KeukenStart.vue?vue&type=script&lang=js&"
export * from "./KeukenStart.vue?vue&type=script&lang=js&"
import style0 from "./KeukenStart.vue?vue&type=style&index=0&id=236ece3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports